import React from "react";

import Grid from "@mui/material/Grid";

import LoadDocumentCmp from "../../../components/thumbnail/loadDocumentCmp";

export default function FurtherInfo(props: any) {
  return (
    <>
      <Grid container xs={12} spacing={2} columns={{ xs: 2, sm: 8, md: 12 }}>
        {props?.data?.map((item: any, index: number) => (
          <Grid item xs={2}>
            <LoadDocumentCmp
              data={item}
              title={true}
              parentPage={"furtherInfo"}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
